import { ISpecialistPreview } from 'app/interfaces/specialists';

export interface IScheduleSlot {
  start_date: string;
  duration: number;
  appointment_id?: string | null;
  service_title?: string | null;
  service_description?: string | null;
  capacity?: number | null;
  specialist: ISpecialistPreview;
}

export interface ICalendarSlot {
  month: string;
  dayOfMonth: string;
  dayOfWeek: string;
  isToday: boolean;
}

export enum TrainingTypeEnum {
  INDIVIDUAL = 'individual',
  GROUP = 'group'
}

export type TrainingType =
  (typeof TrainingTypeEnum)[keyof typeof TrainingTypeEnum];
